<template>
  <b-modal id="edit-cell" :title="$translate('Edit Entry')" hide-footer size="lg" centered content-class="rounded-8" @show="show">
    <div class="row mb-4">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <h6>{{ 'Date' | i18n }}: {{ cell.date }}</h6>
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <h6>{{ 'Employee' | i18n }}: {{ cell.user ? `${cell.user.name} ${cell.user.email ? `(${cell.user.email})` : ''}` : '' }}</h6>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Select
          v-model="shiftPosition"
          :viewMode="!showSave"
          :options="shiftPositionOption"
          form-group-id="Shift Position"
          placeholder="Shift Position"
          :disabled="isNotPresent"
        />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="workingHours" :viewMode="!showSave" type="number" form-group-id="Working Hours" placeholder="Working Hours" />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Select v-model="absence" :viewMode="!showSave" :options="absenceOption" form-group-id="Absence" placeholder="Absence" />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="payInformation" :viewMode="!showSave" form-group-id="Remuneration information" placeholder="Remuneration information" />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Textarea v-model="comment" :viewMode="!showSave" form-group-id="Comment" placeholder="Comment" />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 button-wrapper" v-if="showSave">
        <div v-if="isSaving" class="loader-wrapper">
          <Loader />
        </div>
        <div v-else class="buttons-block">
          <div class="delete-button" @click="clearData">
            {{ 'Clear' | i18n }}
          </div>
          <b-button variant="outline-primary" size="lg" class="btn-delete-device" @click="onSubmit">
            {{ 'Save' | i18n }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from 'moment';
import Select from '../../common/select';
import Input from '../../common/input';
import Loader from '../../common/loader';
import Textarea from '../../common/textarea';
import { ABSENCE_TYPES, ABSENCE_IS_NOT_PRESENT, SHIFTS } from '../../../../../../../constants';
import { NotificationMixin, AuthMixin, DeleteRowMixin } from '../../../../mixins';
import api from '../../../api';
import Notification from '../../common/notification';

export default {
  title: 'Edit shift cell',
  components: { Select, Input, Textarea, Loader },
  mixins: [NotificationMixin, AuthMixin, DeleteRowMixin],
  props: {
    generateShift: {
      type: Function,
      default: () => {},
    },
    cell: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      absence: '',
      shiftPosition: '',
      workingHours: '',
      payInformation: '',
      comment: '',
      absenceOption: [
        ...Object.values(ABSENCE_TYPES)
          .map((i) => ({ value: i, text: this.$translate(i) }))
          .sort((a, b) => {
            var textA = a.value.toUpperCase();
            var textB = b.value.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          }),
      ],
      shiftPositionOption: [],
      shiftPositions: [],
      showSave: true,
      isSaving: false,
    };
  },
  computed: {
    isNotPresent: function () {
      return ABSENCE_IS_NOT_PRESENT.includes(this.absence);
    },
  },
  watch: {
    isNotPresent(newValue) {
      if (newValue) {
        this.shiftPosition = '';
      }
    },
  },
  methods: {
    async show() {
      const now = moment.utc().set({ h: 0, m: 0, s: 0 });
      const dayDate = moment.utc(this.cell.date).set({ h: 23, m: 59, s: 59 });
      this.showSave = (() => {
        if (this.isCommonAdmin) {
          return true;
        }

        if (!dayDate.isAfter(now)) {
          return false;
        }

        const team = this.cell.team;
        const leaders = [];
        if (team.shiftLeader1) {
          leaders.push(team.shiftLeader1.id);
        }
        if (team.shiftLeader2) {
          leaders.push(team.shiftLeader2.id);
        }
        if (team.shiftLeader3) {
          leaders.push(team.shiftLeader3.id);
        }

        if (leaders.includes(this.auth.id)) {
          return true;
        }

        return false;
      })();

      this.absence = null;
      this.shiftPosition = null;
      this.workingHours = '';
      this.payInformation = '';
      this.comment = '';
      this.shiftPositions = await api.shiftPositions.get({ operationalArea: this.cell.operationalArea.id });
      this.shiftPositionOption = [...this.shiftPositions.map((i) => ({ value: i.id, text: i.name }))];
      const d = this.cell.shiftDetails;
      this.shiftPosition = this.cell.shiftPosition && this.cell.shiftPosition.id ? this.cell.shiftPosition.id : null;
      if (this.cell.shiftDetails) {
        this.absence = d.absence ? d.absence : null;
        this.workingHours = d.workingHours;
        this.payInformation = d.payInformation;
        this.comment = d.comment;
      }
    },
    async clearData() {
      await this.deleteSelectedRows(null, async () => {
        const userData = {
          shiftPosition: null,
          shiftDetails: null,
        };
        await this.backendRequest(userData);
      });
    },
    async backendRequest(userData) {
      try {
        this.isSaving = true;
        console.log(this.cell, 'this.cell');
        let users = [];
        if (this.cell.shift !== SHIFTS.OFF_SHIFT) {
          users = this.cell.team.users;

          if (this.cell.shiftDay && this.cell.shiftDay.team) {
            users = this.cell.shiftDay.team.users;
          }
          let exist = false;
          users = users.map((u) => {
            if (u.id === this.cell.user.id) {
              exist = true;
              return {
                ...u,
                ...userData,
              };
            }
            return u;
          });

          if (!exist) {
            users.push({
              ...this.cell.user,
              ...userData,
            });
          }
        } else {
          if (this.cell.shiftDay && this.cell.shiftDay.team) {
            users = this.cell.shiftDay.team.users;
          }
          users.push({
            ...this.cell.user,
            ...userData,
          });
        }

        console.log(users, 'users');
        const data = {
          date: this.cell.date,
          operationalArea: this.cell.operationalArea,
          teamId: this.cell.team.id,
          users,
        };
        await api.shiftDay.save(data);
        await this.generateShift();
        this.$root.$emit('bv::hide::modal', 'edit-cell');
        Notification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        Notification({ type: 'error', message: err.message });
      } finally {
        this.isSaving = false;
      }
    },
    async onSubmit() {
      const userData = {
        shiftPosition: this.shiftPositions ? this.shiftPositions.find((p) => p.id == this.shiftPosition) : null,
        shiftDetails: {
          absence: this.absence,
          workingHours: this.workingHours,
          payInformation: this.payInformation,
          comment: this.comment,
        },
      };
      await this.backendRequest(userData);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #add-team .modal-dialog {
  max-width: 700px !important;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.loader-wrapper {
  height: 50px;
  margin-top: -78px;
  transform: scale(0.5);
  margin-right: 12px;
}
::v-deep .delete-button {
  background: rgb(219, 71, 79);
  color: white;
  border: 2px solid #db474f;
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  display: flex;
}

::v-deep .buttons-block {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px !important;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
